export default __webpack_public_path__ + "static/media/HiMuscat.cafb16a5.webp";